<template>
  <v-card-actions>
    <v-btn
        text color="red"
        v-if="quantityTotal > 0 ? true : false"
        @click="showCancel=true"
    >
      VACIAR
    </v-btn>
    <v-spacer></v-spacer>
    <v-btn
        text color="grey"
        @click="$emit('close')"
    >
      {{ $t('common.close') }}
    </v-btn>
    <v-btn
        class="primary"
        :disabled="!isCartReady"
        @click="$emit('next')"
    >
      {{ $t('common.next') }}
    </v-btn>

    <confirm-dialog
        v-model="showCancel"
        @confirmed="confirmed"
        title="Vaciar Orden"
        description="Esta seguro de vaciar su orden?"
    >

    </confirm-dialog>
  </v-card-actions>
</template>
<script>
import {ConfirmDialog} from '@dracul/common-frontend'
export default {
  name: 'CustomerCartDetailActions',
  components: {ConfirmDialog},
  props: {
    isCartReady: {},
    quantityTotal: {},
  },
  data() {
    return {
      showCancel: false
    }
  },
  methods:{
    confirmed() {
      this.$store.commit('clearItems')
    },
  }
}
</script>
